export default "__VITE_ASSET__CHPoI07L__"